import React, { useEffect, useRef, useState } from "react";
import "./nonMandatoryActions.scss";
import Modal from "react-bootstrap/Modal";
import {
  blackClose,
  modalClose,
  modalCloseIcon,
  uploadIcon,
} from "../../../../../images";
import BusinessFileUpload from "../../../../../components/BusinessFileUpload/BusinessFileUpload";
import style from "../../../../../../src/pages/FormFiveLightTheme/Form/formfivelighttheme.module.scss";
import { useBusinessContext } from "../../../../../context/BusinessAccount/BusinessAccountState";
import { TextField } from "@mui/material";
import { useWindowSize } from "react-use";
import Joi from "joi";
import http from "../../../../../helpers/http";
import config from "../../../../../config/config";
import { toast } from "react-toastify";
import ToastMsg from "../../../../../components/ToastMsg/ToastMsg";
import _ from "lodash";
import CheckboxButton from "../../../../../components/CheckboxButton/CheckboxButton";
import AutoCompleteOthers from "../../../../../components/AutoCompleteOthers/AutoCompleteOthers";
import AutoCompleteField from "../../../../../components/AutoCompleteField/AutoCompleteField";

const NonMandatoryActions = ({
  show,
  onHide,
  handleClose,
  data,
  globalData,
  emptyFields = [],
}) => {
  console.log(emptyFields);
  const [selectedOptions, setSelectedOptions] = useState({
    project_scope: [],
    project_typology: [],
    design_styles: [],
    avg_project_budget: [],
    project_sizes: [],
  });
  const [autoKey, setAutoKey] = useState(1);
  const [formData, setFormData] = useState({
    project_locations: "",
    renovation_work: "",
    avg_project_currency: "",
    project_size_unit: "",
  });
  const [servicesData, setServicesData] = useState({
    project_scope:
      globalData?.project_scope_preferences?.map((it) => ({
        label: it,
        value: it,
      })) || [],
    project_typology:
      globalData?.project_typologies?.map((it) => ({
        label: it,
        value: it,
      })) || [],
    design_styles:
      globalData?.design_styles?.map((it) => ({
        label: it,
        value: it,
      })) || [],
    budgets:
      globalData?.average_budget?.map((it) => ({
        label: it.budget,
        value: it.budget,
        currency: it.currency,
      })) || [],
    sizes:
      globalData?.avg_project_budget?.map((it) => ({
        label: it.budget,
        value: it.budget,
        unit: it.unit,
      })) || [],
  });
  const [initialData, setInitialData] = useState(null);

  // Initialize form with user-selected data
  useEffect(() => {
    const initial = {
      project_locations: data?.project_location?.data || "",
      renovation_work: data?.renovation_work || "",
      project_scope: data?.project_scope?.data || [],
      project_typology: data?.project_typology?.data || [],
      design_styles: data?.design_style?.data || [],
      avg_project_budget: data?.avg_project_budget?.budgets || [],
      avg_project_currency: data?.avg_project_budget?.currency || "",
      project_sizes: data?.avg_project_budget?.budgets || [],
      project_size_unit: data?.avg_project_budget?.unit || "",
    };
    setInitialData(initial);
    setFormData({
      project_locations: initial.project_locations,
      renovation_work: initial.renovation_work,
      avg_project_currency: initial.avg_project_currency,
      project_size_unit: initial.project_size_unit,
    });
    setSelectedOptions({
      project_scope: [],
      project_typology: [],
      design_styles: [],
      avg_project_budget: [],
      project_sizes: [],
    });
  }, [data, show]);

  const handleOptionChange = (value, field) => {
    enableDisableOption(value, true, field);
    setSelectedOptions((prev) => ({
      ...prev,
      [field]: [...prev[field], value],
    }));
  };

  const handleCheckboxChange = (index, value, field) => {
    enableDisableOption(value, false, field);
    const updatedOptions = [...selectedOptions[field]];
    updatedOptions.splice(index, 1);
    setSelectedOptions((prev) => ({
      ...prev,
      [field]: updatedOptions,
    }));
  };

  const enableDisableOption = (value, isDisabled, field) => {
    const selectedIndex = _.findIndex(servicesData[field], { value });
    const updatedOptions = [...servicesData[field]];
    if (updatedOptions[selectedIndex]) {
      updatedOptions[selectedIndex] = {
        ...updatedOptions[selectedIndex],
        disabled: isDisabled,
      };
      setServicesData((prev) => ({
        ...prev,
        [field]: updatedOptions,
      }));
    }
  };

  const handleSelectChange = (value, field) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleRemove = (value, field) => {
    const updatedData = data[field].data.filter((item) => item !== value);
    // Update the parent data (you might need to pass a callback to update parent state)
  };

  const handleSave = async () => {
    try {
      const payload = {
        project_location: { data: formData.project_locations },
        renovation_work: formData.renovation_work,
        project_scope: {
          data: [...data.project_scope.data, ...selectedOptions.project_scope],
        },
        project_typology: {
          data: [
            ...data.project_typology.data,
            ...selectedOptions.project_typology,
          ],
        },
        design_style: {
          data: [...data.design_style.data, ...selectedOptions.design_styles],
        },
        avg_project_budget: {
          budgets: [
            ...data.avg_project_budget.budgets,
            ...selectedOptions.avg_project_budget,
          ],
          currency: formData.avg_project_currency,
        },
        project_sizes: {
          budgets: [
            ...data.avg_project_budget.budgets,
            ...selectedOptions.project_sizes,
          ],
          unit: formData.project_size_unit,
        },
      };
      // TODO: Implement API call
      // await api.saveData(payload);
      handleClose();
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };

  const handleModalClose = () => {
    // Revert to initial data
    setFormData({
      project_locations: initialData?.project_locations || "",
      renovation_work: initialData?.renovation_work || "",
      avg_project_currency: initialData?.avg_project_currency || "",
      project_size_unit: initialData?.project_size_unit || "",
    });
    setSelectedOptions({
      project_scope: [],
      project_typology: [],
      design_styles: [],
      avg_project_budget: [],
      project_sizes: [],
    });
    handleClose();
  };

  // Filter budgets based on selected currency
  const filteredBudgets = servicesData.budgets.filter(
    (budget) => budget.currency === formData.avg_project_currency
  );

  // Filter sizes based on selected unit
  const filteredSizes = servicesData.sizes.filter(
    (size) => size.unit === formData.project_size_unit
  );

  const renderProjectScopeSection = () => {
    const selectedList = selectedOptions.project_scope.map((option, i) => (
      <CheckboxButton
        lightTheme
        isChecked={true}
        label={option}
        labelId={option}
        onChange={() => handleCheckboxChange(i, option, "project_scope")}
        key={`scope-${i}`}
      />
    ));

    return (
      <div className="excel_select_search_wrapper">
        <div className={`${style.steps} ${style.fastep04}`}>
          <div className={`${style.add_more_wrap} ${style.add_more_v2}`}>
            <div className={`${style.field_wrapper} field_wrapper`}>
              <div className="search_select_wrapper">
                <AutoCompleteOthers
                  key={`autokey${autoKey}-project_scope`}
                  lightTheme
                  textLabel="Project Scope"
                  data={
                    globalData?.project_scope_preferences?.map((it) => ({
                      label: it,
                      value: it,
                    })) || []
                  }
                  onChange={(e, value) => {
                    handleOptionChange(value.value, "project_scope");
                    setAutoKey((prev) => prev + 1);
                  }}
                />
              </div>
              <ul className="checkboxes chips_b_edit_autoComplete">
                {data.project_scope?.data?.map((value, index) => (
                  <li
                    className="black_border_chips_custom"
                    key={`scope-chip-${index}`}
                    onClick={() => handleRemove(value, "project_scope")}
                  >
                    {value}
                    <img src={blackClose} alt="close" className="close_icon" />
                  </li>
                ))}
                {selectedList}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderProjectTypologySection = () => {
    const selectedList = selectedOptions.project_typology.map((option, i) => (
      <CheckboxButton
        lightTheme
        isChecked={true}
        label={option}
        labelId={option}
        onChange={() => handleCheckboxChange(i, option, "project_typology")}
        key={`typology-${i}`}
      />
    ));

    return (
      <div className="excel_select_search_wrapper">
        <div className={`${style.steps} ${style.fastep04}`}>
          <div className={`${style.add_more_wrap} ${style.add_more_v2}`}>
            <div className={`${style.field_wrapper} field_wrapper`}>
              <div className="search_select_wrapper">
                <AutoCompleteOthers
                  key={`autokey${autoKey}-project_typology`}
                  lightTheme
                  textLabel="Which types of projects does your business work on?"
                  data={
                    globalData?.project_typologies?.map((it) => ({
                      label: it,
                      value: it,
                    })) || []
                  }
                  onChange={(e, value) => {
                    handleOptionChange(value.value, "project_typology");
                    setAutoKey((prev) => prev + 1);
                  }}
                />
              </div>
              <ul className="checkboxes chips_b_edit_autoComplete">
                {data.project_typology?.data?.map((value, index) => (
                  <li
                    className="black_border_chips_custom"
                    key={`typology-chip-${index}`}
                    onClick={() => handleRemove(value, "project_typology")}
                  >
                    {value}
                    <img src={blackClose} alt="close" className="close_icon" />
                  </li>
                ))}
                {selectedList}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDesignStylesSection = () => {
    const selectedList = selectedOptions.design_styles.map((option, i) => (
      <CheckboxButton
        lightTheme
        isChecked={true}
        label={option}
        labelId={option}
        onChange={() => handleCheckboxChange(i, option, "design_styles")}
        key={`style-${i}`}
      />
    ));

    return (
      <div className="excel_select_search_wrapper">
        <div className={`${style.steps} ${style.fastep04}`}>
          <div className={`${style.add_more_wrap} ${style.add_more_v2}`}>
            <div className={`${style.field_wrapper} field_wrapper`}>
              <div className="search_select_wrapper">
                <AutoCompleteOthers
                  key={`autokey${autoKey}-design_styles`}
                  lightTheme
                  textLabel="What are the Design Styles that your Business can work for?"
                  data={
                    globalData?.design_styles?.map((it) => ({
                      label: it,
                      value: it,
                    })) || []
                  }
                  onChange={(e, value) => {
                    handleOptionChange(value.value, "design_styles");
                    setAutoKey((prev) => prev + 1);
                  }}
                />
              </div>
              <ul className="checkboxes chips_b_edit_autoComplete">
                {data.design_style?.data?.map((value, index) => (
                  <li
                    className="black_border_chips_custom"
                    key={`style-chip-${index}`}
                    onClick={() => handleRemove(value, "design_style")}
                  >
                    {value}
                    <img src={blackClose} alt="close" className="close_icon" />
                  </li>
                ))}
                {selectedList}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="Complete_actions_popup"
      backdropClassName="custom-backdrop"
    >
      <Modal.Header>
        <button className="Complete_actions_popup_cancel_btn" onClick={onHide}>
          <img
            src={modalClose}
            alt="close-icon"
            className="Complete_actions_popup_cancel_btn_img"
          />
        </button>
      </Modal.Header>
      <Modal.Body>
        <h2 className="Complete_actions_popup_m_heading">
          Complete {emptyFields.length} Actions Now For Better Matchmaking
        </h2>
        <div className="excel_select_container">
          {/* Can do Projects */}
          <div className="excel_select_wrapper">
            <AutoCompleteField
              lightTheme
              key="project_locations"
              textLabel="Can do Projects"
              data={
                globalData?.project_locations?.map((it) => ({
                  label: it,
                  value: it,
                })) || []
              }
              value={
                globalData?.project_locations
                  ?.map((it) => ({
                    label: it,
                    value: it,
                  }))
                  .find(
                    (option) => option.value === formData.project_locations
                  ) || null
              }
              onChange={(e, option) =>
                handleSelectChange(option?.value || "", "project_locations")
              }
            />
          </div>

          {/* Renovation Work */}
          <div className="excel_select_wrapper">
            <AutoCompleteField
              lightTheme
              key="renovation_work"
              textLabel="Renovation Work"
              data={[
                { label: "Yes", value: "Yes" },
                { label: "No", value: "No" },
              ]}
              value={
                [
                  { label: "Yes", value: "Yes" },
                  { label: "No", value: "No" },
                ].find((option) => option.value === formData.renovation_work) ||
                null
              }
              onChange={(e, option) =>
                handleSelectChange(option?.value || "", "renovation_work")
              }
            />
          </div>

          {/* Approx Budget of Projects */}
          <div className="excel_select2field_wrapper">
            <div className="excel_select_wrapper">
              <AutoCompleteOthers
                lightTheme
                key={`autokey${autoKey}-avg_project_budget`}
                textLabel="Approx Budget of Projects"
                data={filteredBudgets}
                onChange={(e, value) => {
                  handleOptionChange(value.value, "avg_project_budget");
                  setAutoKey((prev) => prev + 1);
                }}
              />
            </div>
            <div className="excel_select_wrapper">
              <AutoCompleteField
                lightTheme
                key="avg_project_currency"
                textLabel="Currency"
                data={
                  _.uniqBy(globalData?.average_budget, "currency")?.map(
                    (item) => ({
                      label: item.currency,
                      value: item.currency,
                    })
                  ) || []
                }
                value={
                  _.uniqBy(globalData?.average_budget, "currency")
                    ?.map((item) => ({
                      label: item.currency,
                      value: item.currency,
                    }))
                    .find(
                      (option) => option.value === formData.avg_project_currency
                    ) || null
                }
                onChange={(e, option) =>
                  handleSelectChange(
                    option?.value || "",
                    "avg_project_currency"
                  )
                }
              />
            </div>
          </div>

          {/* Current Minimum Project Sizes */}
          <div className="excel_select2field_wrapper">
            <div className="excel_select_wrapper">
              <AutoCompleteOthers
                lightTheme
                key={`autokey${autoKey}-project_sizes`}
                textLabel="Minimum Project Size"
                data={filteredSizes}
                onChange={(e, value) => {
                  handleOptionChange(value.value, "project_sizes");
                  setAutoKey((prev) => prev + 1);
                }}
              />
            </div>
            <div className="excel_select_wrapper">
              <AutoCompleteField
                lightTheme
                key="project_size_unit"
                textLabel="Unit"
                data={
                  _.uniqBy(globalData?.avg_project_budget, "unit")?.map(
                    (item) => ({
                      label: item.unit,
                      value: item.unit,
                    })
                  ) || []
                }
                value={
                  _.uniqBy(globalData?.avg_project_budget, "unit")
                    ?.map((item) => ({
                      label: item.unit,
                      value: item.unit,
                    }))
                    .find(
                      (option) => option.value === formData.project_size_unit
                    ) || null
                }
                onChange={(e, option) =>
                  handleSelectChange(option?.value || "", "project_size_unit")
                }
              />
            </div>
          </div>
        </div>

        {/* Project Scope */}
        {renderProjectScopeSection()}
        {renderProjectTypologySection()}
        {renderDesignStylesSection()}

        <button type="submit" className="popup_common_btn" onClick={handleSave}>
          Save Changes
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default NonMandatoryActions;
